import { DynamicSEO } from '../components/seo';
import Layout from '../components/Layout';
import { Search, Users, Quote, Download } from 'lucide-react';

export default function FeaturesPage() {
  const features = [
    {
      icon: <Search className="w-8 h-8 text-purple-600" />,
      title: "Name Search",
      description: "Search through our extensive database of Nepali names and discover their meanings."
    },
    {
      icon: <Users className="w-8 h-8 text-purple-600" />,
      title: "Name Matching",
      description: "Find compatible names based on cultural and traditional significance."
    },
    {
      icon: <Quote className="w-8 h-8 text-purple-600" />,
      title: "Wisdom Quotes",
      description: "Explore traditional Nepali wisdom through our curated collection of quotes."
    },
    {
      icon: <Download className="w-8 h-8 text-purple-600" />,
      title: "Shareable Content",
      description: "Create and share beautiful images of names and their meanings."
    }
  ];

  return (
    <Layout>
      <DynamicSEO
        meta={{
          title: "Features - NameExplorer's Tools and Capabilities",
          description: "Explore NameExplorer's features including name search, matching, wisdom quotes, and shareable content.",
          type: "website"
        }}
      />
      
      <div className="max-w-6xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 text-center mb-12">Our Features</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-sm p-6 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start gap-4">
                {feature.icon}
                <div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}